import { render, staticRenderFns } from "./sendDialog.vue?vue&type=template&id=ff3d8338&scoped=true&"
import script from "./sendDialog.vue?vue&type=script&lang=js&"
export * from "./sendDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendDialog.vue?vue&type=style&index=0&id=ff3d8338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3d8338",
  null
  
)

export default component.exports